export default __webpack_public_path__ + "assets/images/11ccdbf9eab48470778d95bf7d9eb5e3.jpeg";